import { DataSource } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CustomerService } from '../../../shared/services/customer.service';

export interface CustomerPreviousHiresItem {
  id: number;
  docket_id: number;
  account_reference: string;
  quantity: number;
  product_name: string;
  product_id: number;
  item_id: number;
  item_name: string;
  on_hire: string;
  off_hire: string;
  charge: number;
  currency: string;
  currency_rate: number;
  docket_status: string;
  created_at: string;
}
export class PreviousHiresDataSource extends DataSource<CustomerPreviousHiresItem> {
  private previousHiresSubject = new BehaviorSubject<
    CustomerPreviousHiresItem[]
  >([]);
  private loadingSubject = new BehaviorSubject<boolean>(true);
  private totalCountSubject = new BehaviorSubject<number>(0);

  public loading$ = this.loadingSubject.asObservable();
  public totalCount$ = this.totalCountSubject.asObservable();

  constructor(private customerService: CustomerService) {
    super();
  }

  connect(): Observable<CustomerPreviousHiresItem[]> {
    return this.previousHiresSubject.asObservable();
  }

  disconnect(): void {
    this.previousHiresSubject.complete();
    this.loadingSubject.complete();
    this.totalCountSubject.complete();
  }

  loadPreviousHires(
    customerId: number,
    paginator: MatPaginator,
    sort: MatSort,
    onlyActive: boolean
  ) {
    this.loadingSubject.next(true);

    const params = {
      page: (paginator.pageIndex + 1).toString(),
      perPage: paginator.pageSize.toString(),
      sortBy: sort.active || 'on_hire',
      sortOrder: sort.direction || 'desc'
    };

    this.customerService
      .getPreviousHires(customerId, { ...params, onlyActive })
      .pipe(
        catchError(() => of({ data: [], count: 0 })),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe((response) => {
        this.previousHiresSubject.next(response.data);
        this.totalCountSubject.next(response.count);
      });
  }
}
